import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { MantineProvider } from '@mantine/core'
import { I18nextProvider } from 'react-i18next'
import { queryClient } from '@/queryClient'
import { theme } from './config/theme.ts'

import "@mantine/core/styles.css"
import '@mantine/notifications/styles.css';
import '@mantine/carousel/styles.css';
import '@mantine/dropzone/styles.css';
import '@mantine/tiptap/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/code-highlight/styles.css';
import './App.css';

import App from './App.tsx'
import i18n from './lib/i18n.ts'
import { SentryProvider } from '@/sentry-ready'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <SentryProvider
    config={{
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.VITE_APP_ENV || import.meta.env.MODE,
      release: import.meta.env.VITE_APP_VERSION,
      // Only report in production builds; `bun dev` never sends events.
      enabled: import.meta.env.PROD,
    }}
  >
    <I18nextProvider i18n={i18n} defaultNS={'translation'}>
      <QueryClientProvider client={queryClient}>
        <MantineProvider theme={theme} defaultColorScheme="dark">
          <App />
        </MantineProvider>
      </QueryClientProvider>
    </I18nextProvider>
  </SentryProvider>,
)
